import script from "./WaitlistForm.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitlistForm.vue?vue&type=script&setup=true&lang=js"

import "./WaitlistForm.vue?vue&type=style&index=0&id=6a1bfc31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1bfc31"]])

export default __exports__